/** @format */

import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-700  bottom-0 ">
        <p className="text-sm text-gray-400 text-center py-4">
          &copy; 2024 3D Configurator. All rights reserved.
        </p>
    </footer>
  );
};

export default Footer;
